// Externe Bibliotheken
import React, { Component } from 'react';
import _ from 'lodash';

// Interne Module
import * as storage from '@/_helper/storage';
import { convertDate } from '@/_helper/mapper';

class SeatReservation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: this.props.params,
            bookedSeats: this.props.bookedSeats,
            flightDetails: this.props.flightDetails,
            seatReservations: this.props.seatReservations,
            cancellationData: storage.get('cancellationData'),
            alreadyTested: this.props.alreadyTested,
            data: {},
            checkHelper: {
                all: false,
            },
        };

        this.getCheckedServiceDetails = this.getCheckedServiceDetails.bind(this);
    }

    componentDidMount() {
        if (!this.state.cancellationData) {
            return false;
        }

        this.checkPossibleSeats();
        this.getCheckedServiceDetails();
    }

    getCheckedServiceDetails() {
        const { checkHelper, data, seatReservations } = this.state;

        let checkedServiceDetails = {
            seatReservationBookingIds: [],
        };

        _.filter(checkHelper, function (v, i) {
            if (i !== 'all' && v) {
                // get seatReservation booking ID by booked seats offerkey and state
                let seatReservationBookingId = Object.keys(seatReservations).filter(function (o) {
                    return seatReservations[o]?.state === 'OK' && o.includes(data[i].offerKey);
                })[0];

                if (seatReservationBookingId && seatReservations[seatReservationBookingId].state === 'OK') {
                    checkedServiceDetails.seatReservationBookingIds.push(seatReservationBookingId);
                }
            }
        });

        this.setState({ getCheckedServiceDetails: checkedServiceDetails });

        this.props.getCheckedServiceDetailsChange(checkedServiceDetails);
    }
    checkPossibleSeats() {
        const { bookedSeats, params, checkHelper, cancellationData } = this.state;
        const refs = params.get('ref') && params.get('ref').split(',');
        let cancellationAllowed = true;

        let data = {};

        refs.forEach((item, index) => {
            let getIndex = _.findIndex(bookedSeats, function (o) {
                return o.offerKey === item;
            });

            if (getIndex >= 0) {
                // add cancellationData
                Object.entries(cancellationData?.seatReservation).forEach(function (value) {
                    if (value[0].includes(item)) {
                        // check cancellation allowed
                        cancellationAllowed = value[1].cancellationAllowed;

                        // set cancellationData to booked seat
                        bookedSeats[getIndex] = {
                            ...bookedSeats[getIndex],
                            cancellationData: value[1],
                        };
                    }
                });

                if (bookedSeats[getIndex] && cancellationAllowed) {
                    data[index] = bookedSeats[getIndex];
                    checkHelper[index] = false;
                }
            }
        });

        // remove duplicates
        data = [...new Map(Object.values(data).map((v) => [v.offerKey, v])).values()];

        this.setState(
            {
                data: data,
                checkHelper: checkHelper,
            },
            () => {
                // no data -> redirect
                if (Object.keys(this.state.data).length === 0) {
                    window.location.href = '#/leistung-stornieren/sitzplatzreservierung';
                }

                this.getFlightDetails();
            }
        );
    }
    getFlightDetails() {
        const { data, flightDetails } = this.state;

        let titleMapping = {
            outbound: 'Hinflug',
            inbound: 'Rückflug',
        };

        let legData = {};

        const dateString = (value) => {
            let departureDate = new Date(convertDate(value.depDate));
            let dateString;

            const options = {
                weekday: 'short',
                year: 'numeric',
                month: 'long',
                day: '2-digit',
            };

            dateString = departureDate.toLocaleString('de-DE', options);

            return dateString;
        };
        const connectionLine = (value) => {
            return `${value.depAirportDescription} (${value.depAirportCode}) - ${value.arrAirportDescription} (${value.arrAirportCode})`;
        };

        Object.values(data).forEach((item) => {
            _.forEach(flightDetails, function (value, key) {
                if (
                    _.filter(value, {
                        depAirportCode: item.departureAirport,
                    }).length > 0
                ) {
                    let legDataIndex = _.findIndex(flightDetails[key], function (o) {
                        return o.depAirportCode === item.departureAirport;
                    });

                    legData = {
                        title: `${titleMapping[key]}${Object.values(flightDetails[key]).length > 1 ? `: Teilstrecke ${legDataIndex + 1}` : ``}`,
                        connection: connectionLine(value[0]),
                        date: dateString(value[0]),
                    };
                }
            });
        });

        // store data
        this.setState({
            legData: legData,
        });
    }
    handleCheck(index) {
        let { checkHelper, data } = this.state;
        checkHelper[index] = !checkHelper[index];

        if (index === 'all') {
            Object.keys(checkHelper).forEach((v) => (checkHelper[v] = true));
        } else {
            // if all seats are to be canceled -> all selected
            let getSelectedCount = _.filter(checkHelper, function (o, i) {
                if (i !== 'all') {
                    return o;
                }
            }).length;

            checkHelper['all'] = Object.keys(data).length === getSelectedCount;
        }

        this.setState(
            {
                checkHelper: checkHelper,
            },
            () => {}
        );

        this.getCheckedServiceDetails();
    }

    render() {
        let { data, checkHelper, legData } = this.state;
        let { alreadyTested } = this.props;

        let nothingSelected = alreadyTested && Object.values(checkHelper).filter((check) => check).length === 0;

        return (
            <>
                <section className="card">
                    <div className="head card-row flex-wrap">
                        <h2>Welche Sitzplätze sollen storniert werden?</h2>

                        {nothingSelected && <p className="error">Wählen Sie einen Sitzplatz zum Storieren aus.</p>}
                    </div>
                    <div
                        className={`participants card-row flex-column ${nothingSelected ? 'error-nothing-selected' : ''}`}>
                        {Object.values(data).map((item, index) => {
                            return (
                                <div key={index} className="entry flex flex-between">
                                    <div className="checkbox-input">
                                        <input
                                            type="checkbox"
                                            name={`cancellation-accept-participant-${index}`}
                                            id={`cancellation-accept-participant-${index}`}
                                            onChange={() => this.handleCheck(index)}
                                            checked={checkHelper[index] && checkHelper[index]}
                                        />
                                        <span className="icon" onClick={() => this.handleCheck(index)}></span>
                                        <label
                                            htmlFor={`cancellation-accept-participant-${index}`}
                                            style={{ '--hook-color': 'white' }}>
                                            {item.participant?.firstName} {item.participant?.lastName}
                                        </label>
                                    </div>
                                    <div className="seat text-bold">{item.seat}</div>
                                </div>
                            );
                        })}

                        {Object.keys(data).length > 1 && (
                            <div className="checkbox-input all">
                                <input
                                    type="checkbox"
                                    name={`cancellation-accept-all`}
                                    id={`cancellation-accept-all`}
                                    onChange={() => this.handleCheck('all')}
                                    checked={checkHelper['all'] && checkHelper['all']}
                                />
                                <span className="icon"></span>
                                <label className="noLineBreak" htmlFor={`cancellation-accept-all`}>
                                    Alle Sitzplätze auf einmal stornieren
                                </label>
                            </div>
                        )}
                    </div>
                    <hr />
                    <div className="card-row space-between flex-wrap leg-data">
                        <div>{legData?.title}</div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: legData?.connection,
                            }}></div>
                    </div>
                    <div className="card-row space-between flex-wrap flight-date">
                        <div>Flugdatum</div>
                        <div>{legData?.date}</div>
                    </div>
                    <hr />
                    <div className="card-row space-between">
                        <div>Reisepreis</div>
                        <div className="noLineBreak">{this.props.prices.packagePrice}</div>
                    </div>
                    <div className="card-row space-between text-bold">
                        <div>Rückerstattung Sitzplatzreservierung</div>
                        <div className="noLineBreak">0,00 €</div>
                    </div>
                </section>
            </>
        );
    }
}

export default SeatReservation;
